import {Inject, Injectable} from '@angular/core';
import { AllService } from './all.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import {InterfaceService} from "./interface.service";
import {DcService} from './dc.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  arConfig: any = {
    read_btn: {
      value: false
    },
    theme: {
      value: ''
    },
    message_show: {
      value: true
    },
    message_sound: {
      value: true
    },
    message_show_text: {
      value: true
    },
    dev: {
      value: false
    },
    title: {
      value: false
    },
    font_size: {
      value: 100
    },
    compact: {
      value: false
    }
  };
  Form: UntypedFormGroup;
  constructor(
    private dcService: DcService,
    public allService: AllService
  ) {
    const arLocalConfig = this.allService.getVarLocal('config', {}, 'all');
    if (Object.keys(arLocalConfig)?.length > 0) {
      this.arConfig = arLocalConfig;
    }
    this.initForm();
  }
  set(key: string, value: any): void {
    // log(value);
    this.arConfig[key] = value;
    this.allService.setVarLocal('config', this.arConfig);
  }
  get(key: string): any {
    return this.arConfig[key];
  }
  initForm(): void {
    this.Form = new UntypedFormGroup({});
    Object.keys(this.arConfig).forEach((key) => {
      const field = this.arConfig[key];
      this.Form.addControl(key, new UntypedFormControl(field?.value));
    });
    this.Form.valueChanges.subscribe((v) => {
      Object.keys(this.Form.value).forEach((key) => {
        this.arConfig[key].value = this.Form.value[key];
      });
      // if(this.themeService.systemTitleBar !== this.arConfig.title) {
      // TODO this.themeService.systemTitleBar = this.arConfig.title;
      // }
      this.allService.setVarLocal('config', this.arConfig, 'all');
      setTimeout(() => {
        this.dcService.detectChanges$.next('messages-scroll');
      }, 100);
    });
  }
}
